import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    empty: {
      width: 150,
      height: 150,
      borderRadius: '50%',
      // backgroundColor: Colors.PURPLE,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    emptyName: {
      textDecoration: 'uppercase',
      color: Colors.WHITE,
      fontSize: '3.5rem',
      fontWeight: 450,
    },
    emptySmallSize: {
      width: 50,
      height: 50,
      borderRadius: '50%',
      // backgroundColor: Colors.PURPLE,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    emptyNameSmallSize: {
      textDecoration: 'uppercase',
      color: Colors.WHITE,
      fontSize: '1.5rem',
      fontWeight: 450,
    },
    image: {
      borderRadius: '50%',
      ...CommonFonts.darkFont12,
      justifyContent: 'center',
      alignItems: 'center',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        filter: 'brightness(0.7)',
        transition: 'all 0.2s ease-in-out',
      },
    },
    button: {
      padding: 0,
    },
    searchInput: {
      padding: theme.spacing(3, 0),
      '& .MuiInputBase-input': {
        fontSize: 16,
      },
      '& .MuiSvgIcon-root': {
        fontSize: 20,
        color: '#bec7cc',
      },
    },
    noItemFound: {
      ...CommonFonts.darkFont16,
      marginTop: theme.spacing(5),
    },
    boxSlider: {
      padding: theme.spacing(5, 50),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(5, 25),
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(5, 0),
      },
    },
  })
);

export default useStyles;
